export default "__VITE_ASSET__fe35c0b3__"